<template>
  <div>
    <em>{{ $t("form.working_hours.option_b.help") }}</em>

    <div>
      <div>
        <label for="option_b_monday">{{
          $t("form.working_hours.days.monday")
        }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="option_b_monday"
            :placeholder="$t('form.working_hours.option_b.day.placeholder')"
            v-model="days.monday"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
            autocomplete="off"
          />
          <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
        </div>
      </div>
    </div>

    <div>
      <div>
        <label for="option_b_tuesday">{{
          $t("form.working_hours.days.tuesday")
        }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="option_b_tuesday"
            :placeholder="$t('form.working_hours.option_b.day.placeholder')"
            v-model="days.tuesday"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
            autocomplete="off"
          />
          <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
        </div>
      </div>
    </div>

    <div>
      <div>
        <label for="option_b_wednesday">{{
          $t("form.working_hours.days.wednesday")
        }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="option_b_wednesday"
            :placeholder="$t('form.working_hours.option_b.day.placeholder')"
            v-model="days.wednesday"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
            autocomplete="off"
          />
          <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
        </div>
      </div>
    </div>

    <div>
      <div>
        <label for="option_b_thursday">{{
          $t("form.working_hours.days.thursday")
        }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="option_b_thursday"
            :placeholder="$t('form.working_hours.option_b.day.placeholder')"
            v-model="days.thursday"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
            autocomplete="off"
          />
          <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
        </div>
      </div>
    </div>

    <div>
      <div>
        <label for="option_b_friday">{{
          $t("form.working_hours.days.friday")
        }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="option_b_friday"
            :placeholder="$t('form.working_hours.option_b.day.placeholder')"
            v-model="days.friday"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
            autocomplete="off"
          />
          <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
        </div>
      </div>
    </div>

    <div>
      <div>
        <label for="option_b_saturday">{{
          $t("form.working_hours.days.saturday")
        }}</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="option_b_saturday"
            :placeholder="$t('form.working_hours.option_b.day.placeholder')"
            v-model="days.saturday"
            @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
            required
            autocomplete="off"
          />
          <!-- <div class="invalid-feedback">
                  <invalid-cross></invalid-cross>
                  <span>{{ $t('form.validation_error_message') }}</span>
                </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      days: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
      },
    };
  },
  watch: {
    days: {
      handler() {
        this.$store.commit("updateWorkingHoursInputB", this.days);
      },
      deep: true,
    },
  },
};
</script>
